function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import axios from 'axios';
import AxiosUtils from '../../utilities/axios-utils';
import ConfigurationManager from '../configuration-manager';
import CheckUtils from '../../utilities/check-utils';

/**
 * @memberOf module:wdh-feature-b2b
 */
var ApiClientCategory = /*#__PURE__*/function () {
  function ApiClientCategory(token) {
    _classCallCheck(this, ApiClientCategory);
    this.token = token;
  }
  return _createClass(ApiClientCategory, [{
    key: "initErrorHandling",
    value: function initErrorHandling(callback) {
      this.errorHandlingCallback = callback;
    }

    /**
     * Get bulk order categories
     * NOTICE: Always gets children. The result format might be different than the Client Library.
     */
  }, {
    key: "getBulkOrderCategories",
    value: function getBulkOrderCategories() {
      var _this = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/category/catalogStructure/quickOrder', AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
    * Gets display columns for a category
    */
  }, {
    key: "getCategoryDisplayColumns",
    value: function getCategoryDisplayColumns(categoryId) {
      var _this2 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/category/categoryStructure/displaycolumns/".concat(CheckUtils.isNullOrEmptyNumber(categoryId) ? '' : categoryId), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this2.token)).then(function (response) {
          resolve(response.data.columns);
        }).catch(function (err) {
          reject(err);
          _this2.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Gets display columns for a category
     */
  }, {
    key: "getCategoryDisplayColumnsForAccessories",
    value: function getCategoryDisplayColumnsForAccessories(categoryId) {
      var _this3 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get("/api/category/categoryStructure/displaycolumns/".concat(CheckUtils.isNullOrEmptyNumber(categoryId) ? '' : categoryId), AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this3.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this3.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }

    /**
     * Get client order categories
     * NOTICE: Always gets children. The result format might be different than the Client Library.
     */
  }, {
    key: "getClientOrderCategories",
    value: function getClientOrderCategories() {
      var _this4 = this;
      var promise = new Promise(function (resolve, reject) {
        axios.get('/api/category/catalogStructure/clientOrder', AxiosUtils.getConfig(ConfigurationManager.getShopServiceEndPoint(), _this4.token)).then(function (response) {
          resolve(response.data);
        }).catch(function (err) {
          reject(err);
          _this4.errorHandlingCallback(err.response.data);
        });
      });
      return promise;
    }
  }]);
}();
export default ApiClientCategory;